import { __awaiter } from "tslib";
import { ChoreographerPlugin } from './types';
import { MessageDeliveryStatus, ProductIds } from '../constants';
export class EngagekitChoreographerPlugin extends ChoreographerPlugin {
    constructor(env, metaMetricsData = {}) {
        super(ProductIds.ENGAGEKIT, env, metaMetricsData);
    }
    startMessageWithPlugin(messageId_1, callback_1) {
        return __awaiter(this, arguments, void 0, function* (messageId, callback, additionalData = {}) {
            // Do a just-in-time message start subscription with our callback to stargate
            this.onStart(messageId, callback);
            /**
             * Dispatch the request to start the message, and return the response, which will
             * either be 'started' if successful, and anything else if unsuccessful. Convert
             * that value with a boolean check, because the consumer only cares about true/false.
             */
            const result = yield this.startMessage(messageId, additionalData);
            return result === MessageDeliveryStatus.STARTED;
        });
    }
    stopMessageWithPlugin(messageId_1, callback_1) {
        return __awaiter(this, arguments, void 0, function* (messageId, callback, additionalData = {}) {
            // Do a just-in-time message stop subscription with our callback to stargate
            this.onStop(messageId, callback);
            /**
             * Dispatch the request to stop the message, and return the response, which will
             * either be 'stopped' if successful, and anything else if unsuccessful. Convert
             * that value with a boolean check, because the consumer only cares about true/false.
             */
            const result = yield this.stopMessage(messageId, additionalData);
            return result === MessageDeliveryStatus.STOPPED;
        });
    }
}
//# sourceMappingURL=EngagekitChoreographerPlugin.js.map